import { Component, input, model } from '@angular/core';
import { SvgIconComponent } from 'angular-svg-icon';

@Component({
  selector: 'app-accordion',
  imports: [SvgIconComponent],
  templateUrl: './accordion.component.html',
})
export class AccordionComponent {
  readonly title = input('');
  readonly titleClass = input('text-button-secondary-color');
  readonly open = model(false);
  readonly disabled = input(false);
  readonly badgeIcon = input<string | null>(null);
  readonly badge = input<string | null>(null);
  readonly badgeClass = input('chip chip-slim chip-completed');

  toggle(): void {
    if (this.disabled()) {
      return;
    }
    this.open.set(!this.open());
  }
}
